/**
 * 지도 카메라를 부드럽게 옮기는 보간 — **순수 함수**.
 *
 * `fitBounds`·`setZoom` 은 순간 이동이라 겹친 핀을 눌렀을 때 "확" 확대됐다. 검색 지도는
 * 소수 줌을 쓰는 벡터 지도라, 프레임마다 `moveCamera` 로 조금씩 옮기면 부드럽게 이어진다.
 * 여기엔 "그 순간 카메라가 어디 있어야 하나"만 두고, 프레임 구동은 MapView 가 한다.
 */

export interface CameraPose {
  lat: number;
  lng: number;
  zoom: number;
}

/** 천천히 출발해 천천히 멈춘다 — 순간 이동처럼 보이지 않게. */
export function easeInOutCubic(t: number): number {
  const x = Math.min(1, Math.max(0, t));
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}

/**
 * 진행률 t(0~1)에서의 카메라. 줌은 이미 로그 척도라 선형으로 이으면 화면에선 일정한
 * 속도로 커진다. 중심은 짧은 거리(눌린 핀 주변)만 움직여 선형으로 충분하다.
 */
export function cameraAt(from: CameraPose, to: CameraPose, t: number): CameraPose {
  if (t <= 0) return from;
  if (t >= 1) return to;
  const k = easeInOutCubic(t);
  return {
    lat: from.lat + (to.lat - from.lat) * k,
    lng: from.lng + (to.lng - from.lng) * k,
    zoom: from.zoom + (to.zoom - from.zoom) * k,
  };
}

const MIN_MS = 280;
const PER_ZOOM_MS = 160;
const MAX_MS = 900;

/** 줌 차이가 클수록 조금 더 길게 — 단, 기다리게 하지 않도록 상한을 둔다. */
export function tweenDurationMs(fromZoom: number, toZoom: number): number {
  return Math.min(MAX_MS, MIN_MS + PER_ZOOM_MS * Math.abs(toZoom - fromZoom));
}
